import React, { useMemo } from 'react';
import './FooterSection.css';
import { FaLinkedin, FaFacebook, FaTwitter, FaInstagram, FaTiktok } from 'react-icons/fa';

const socialLinks = [
  { href: "https://www.linkedin.com/company/104620553", icon: <FaLinkedin size={24} />, label: "LinkedIn" },
  { href: "https://www.facebook.com/astrasighttech", icon: <FaFacebook size={24} />, label: "Facebook" },
  { href: "https://twitter.com/astrasighttech", icon: <FaTwitter size={24} />, label: "Twitter" },
  { href: "https://instagram.com/astrasighttech", icon: <FaInstagram size={24} />, label: "Instagram" },
  { href: "https://www.tiktok.com/@astrasighttech", icon: <FaTiktok size={24} />, label: "TikTok" }
];

const Footer = () => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* About Section */}
        <div className="footer-section">
          <h4 className="footer-title">AstraSight Technologies</h4>
          <p>
            Leading in <strong>web development, SEO, software solutions, cybersecurity, and digital branding</strong>. 
            We empower businesses with <strong>cutting-edge technology and innovative strategies</strong> for growth.
          </p>
        </div>
        
        {/* Quick Links */}
        <div className="footer-section">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-links">
            {["About Us", "Our Services", "Portfolio", "Contact", "Privacy Policy"].map((text, index) => (
              <li key={index}><a href={`/${text.toLowerCase().replace(/\s/g, "-")}`}>{text}</a></li>
            ))}
          </ul>
        </div>
        
        {/* Contact Information */}
        <div className="footer-section">
          <h4 className="footer-title">Get in Touch</h4>
          <p>Email: <a href="mailto:info@astrasighttech.com">info@astrasighttech.com</a></p>
          <p>Phone: <a href="tel:+254791865638">+254 7918 65638</a></p>
          <p>Location: Gracewood Plaza, Kikuyu</p>
        </div>
        
        {/* Social Media Links */}
        <div className="footer-section">
          <h4 className="footer-title">Follow Us</h4>
          <div className="social-links">
            {socialLinks.map(({ href, icon, label }, index) => (
              <a key={index} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                {icon}
              </a>
            ))}
          </div>
        </div>

      </div>

      {/* Bottom Row */}
      <div className="footer-bottom">
        <p>&copy; {currentYear} <strong>AstraSight Technologies</strong>. All rights reserved.</p>
        <p>🚀 Powered by <strong>AstraSight Technologies</strong></p>
      </div>
    </footer>
  );
}

export default Footer;
